import { UserInfo, UserPlan } from '@pt/types/user.type'
import { Plan } from '@ve-pro/api/project/type'
import { MainPlan, ExtraPlan } from '@ve-pro/enums/plan'
import { useProjectStore } from '..'

// -1为无限量
const UNLIMITED = -1

/**
 * 计算套餐 [number, number] index 0 为余量，index 1 为总量, 值为-1无限量
 * @param plans UserInfo['plans']
 * @returns Plan
 */
export function getUserPackageData(user: UserInfo | null): Plan {
  const plan: Plan = {
    downloads_and_push: [0, 0],
    video_credits: [0, 0],
  }

  if (user === null || user.plans === null || user.plans.length === 0) {
    return plan
  }

  plan.downloads_and_push = getUserPackageItem(
    user.plans,
    MainPlan.downloads,
    ExtraPlan.extra_downloads,
  )

  plan.video_credits = getUserPackageItem(
    user.plans,
    MainPlan.video_credits,
    ExtraPlan.extra_video_credits,
  )

  return plan
}

function getUserPackageItem(
  plans: UserPlan[],
  main: MainPlan,
  extra: ExtraPlan,
): [number, number] {
  // 无限量为-1
  if (plans[0] && plans[0][main] && plans[0][main][0] === UNLIMITED) {
    return [UNLIMITED, UNLIMITED]
  }

  return plans.reduce(
    (previousValue, plan) => {
      return [
        (plan[main][0] ?? 0) + (plan[extra][0] ?? 0) + previousValue[0],
        (plan[main][1] ?? 0) + (plan[extra][1] ?? 0) + previousValue[1],
      ]
    },
    [0, 0],
  )
}
